import { useQueryClient } from "@tanstack/react-query";

import { authClient } from "@/utils/auth-client";

export function useAuthActions() {
  const queryClient = useQueryClient();

  //   async function signIn(credentials: any) {
  //     const session = await authClient.signIn(credentials);
  //     queryClient.setQueryData(["session"], session);
  //   }

  async function signOut() {
    await authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          window.location.href = "/login";
        },
      },
    });
    queryClient.setQueryData(["session"], null);
  }

  return {
    // signIn,
    signOut,
  };
}
